module.exports = __webpack_public_path__ + "9aa25a575750b1136b8d02dc99886ccc.jpg";